export const INTEGRATE_CONFLUENCE = 'integrate_confluence';
export const INTEGRATE_DROPBOX = 'integrate_dropbox';
export const INTEGRATE_GITHUB = 'integrate_github';
export const INTEGRATE_GITLAB = 'integrate_gitlab';
export const INTEGRATE_GMAIL = 'integrate_gmail';
export const INTEGRATE_GOOGLE_DOCS = 'integrate_google_docs';
export const INTEGRATE_HACKER_NEWS = 'integrate_hacker_news';
export const INTEGRATE_INTERCOM = 'integrate_intercom';
export const INTEGRATE_JIRA = 'integrate_jira';
export const INTEGRATE_INVISION = 'integrate_invision';
export const INTEGRATE_PRODUCTHUNT = 'integrate_producthunt';
export const INTEGRATE_SALESFORCE = 'integrate_salesforce';
export const INTEGRATE_SALESFORCE_IQ = 'integrate_salesforce_iq';

export const ENABLED = 'enabled';
export const EXPAND = 'expand';
export const HINT = 'hint';

// You can change the display order of integrations on the Integrations Settings page by changing the order of the items below.
/* To add a new integration:
   1. Copy the syntax shown on this page for the new integration
   2. Add the svg logo to shared/assets/img/logos
   3. Confirm that the integration settings displays properly on the Account Settings page (loom.com/account-settings)
   4. Update the default value of the integration_column of the user model in user.js to include the new integration if not already included
   5. If you updated the default value then create a db migration for the change
   6. Add the url of the website you're integrating with in the chrome extension repo
   7. Links on that website should now expand, test to make sure they look good and potentially customize the video player for that website
*/
export const INTEGRATIONS = {
  [INTEGRATE_GMAIL]: {
    logo: 'gmail.svg',
    name: 'Gmail',
    description: 'Create and share quick videos right from your inbox',
  },
  [INTEGRATE_INTERCOM]: {
    logo: 'intercom.svg',
    name: 'Intercom',
    description: 'Communicate with customers the new way with quick videos',
  },
  [INTEGRATE_GITHUB]: {
    logo: 'github.svg',
    name: 'GitHub',
    description: 'Built for developers, quick videos are for all things GitHub',
  },
  [INTEGRATE_JIRA]: {
    logo: 'jira.svg',
    name: 'JIRA',
    description: 'Stay agile with quick videos in JIRA',
  },
  [INTEGRATE_GOOGLE_DOCS]: {
    logo: 'docs.svg',
    name: 'Google Docs',
    description: 'Bring GDocs to life with quick videos',
  },
  [INTEGRATE_HACKER_NEWS]: {
    logo: 'y-combinator.svg',
    name: 'Hacker News',
    description: 'Remain on topic with quick videos in Hacker News',
  },
  // [INTEGRATE_CONFLUENCE]: {
  //   logo: 'confluence.svg',
  //   name: 'Confluence',
  //   description: 'Confluence made better with quick videos',
  // },
  [INTEGRATE_INVISION]: {
    logo: 'invision.svg',
    name: 'Invision',
    description: 'Design better. Faster. Together. With quick videos',
  },
  [INTEGRATE_DROPBOX]: {
    logo: 'dropbox.svg',
    name: 'Dropbox',
    description:
      'Reinventing teamwork just got a little easier with quick videos',
  },
  [INTEGRATE_PRODUCTHUNT]: {
    logo: 'producthunt.svg',
    name: 'Product Hunt',
    description: 'Get the best comments in ProductHunt daily with quick videos',
  },
  [INTEGRATE_GITLAB]: {
    logo: 'gitlab.svg',
    name: 'GitLab',
    description:
      'Platform for modern developers even more modern with quick videos',
  },
  [INTEGRATE_SALESFORCE]: {
    logo: 'salesforce.svg',
    name: 'Salesforce',
    description: 'Success. Not software. With quick videos',
  },
  [INTEGRATE_SALESFORCE_IQ]: {
    logo: 'iq.svg',
    name: 'SalesforceIQ',
    description: "Quick videos for growing business's CRM",
  },
};

export const ALL = [
  INTEGRATE_CONFLUENCE,
  INTEGRATE_DROPBOX,
  INTEGRATE_GITHUB,
  INTEGRATE_GITLAB,
  INTEGRATE_GMAIL,
  INTEGRATE_GOOGLE_DOCS,
  INTEGRATE_HACKER_NEWS,
  INTEGRATE_INTERCOM,
  INTEGRATE_JIRA,
  INTEGRATE_INVISION,
  INTEGRATE_PRODUCTHUNT,
  INTEGRATE_SALESFORCE,
  INTEGRATE_SALESFORCE_IQ,
];
